<template>
  <div class="overall-bg">
    <b-container fluid="xl" class="tabviewtable">
      <b-row v-if="tstatus == true">
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('ItemCategory.StoreCategoryMapping.List')" :contenttext="$t('ItemCategory.StoreCategoryMapping.TableHeaderContent')
            ">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <b-col>
          <div class="" v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty :createline="IsAddButton" v-if="List.length === 0 && !loading" eheader="Store Category"
                econtent="Store Category" eimg="/src/assets/Img/icons/subgroupmaster.svg" @createNew="IsAdd" />
              <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                @row-click="" :exceldownload="true">
                <template v-slot:Add v-if="IsAddButton">
                  <span class="add">
                    <AddButton :btnname="$t('btn.plusaddnew')" class="float-rights my-3" @click="IsAdd()" />
                  </span>
                </template>

                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Store Category Mapping" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:CategoryCount="{ data }">
                  <p @click="navigatetopage(data.ItemCount, data)">
                    {{ data.CategoryCount }}
                  </p>
                </template>
                <template v-slot:action="{ data }">
                  <span>
                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" eheader="Store Category" econtent="Store Category"
                eimg="/src/assets/Img/icons/subgroupmaster.svg" @createNew="IsAdd" />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <p class="name">{{ item.StoreName }}</p>
                      </div>
                      <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Category Count :</p>
                      <p class="small-name">{{ item.CategoryCount }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <StoreCategoryMappingmodal v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
    @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
    @loadershow="loading = true" :OperationID="ObjOperationId" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import StoreCategoryMappingmodal from "./StoreCategoryMappingCreation.vue";
import GenericService from "../../../../Service/GenericMasterService";
import FilterSidebar from "../../../Masters/Pharmacy/GenericMaster/GenericmasterFilter.vue";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DeleteIcon from "../../../../../../components/GeneralButtons/DeleteIcon.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MobileView from "../../../../../../modules/Inventory/pages/Masters/Pharmacy/GenericMaster/GenericMasterMobileViewCard.vue";
import ItemStoreMappingService from "../../../../Service/ItemStoreMappingService";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import { RouterLink, RouterView, useRoute, useRouter } from "vue-router";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    StoreCategoryMappingmodal,
    FilterSidebar,
    Tableview,
    DeleteConfirmationVue,
    Loader,
    DeletedSuccessfully,
    EditConfirmation,
    Mapping,
    MobileView,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  props: {
    tstatus: {
      default: true,
      type: Boolean,
    },
    IsAddButton: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const toast = useToast();
    const generic = ref();
    let loading1 = ref(false);
    const showDialog = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const rowFocus = ref(false);
    let deletepop = ref(false);
    const dataEdit = ref();
    let contentName = ref("");
    const MappingPopUp = ref(false);
    const isMobile = ref(false);
    const router = useRouter();
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    let loading = ref(false);

    let List: any = ref([]);

    const headers = [
      {
        header: t('ItemCategory.StoreCategoryMapping.sno'),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      {
        header: t('ItemCategory.StoreCategoryMapping.Store'),
        field: "StoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('ItemCategory.StoreCategoryMapping.Category'),
        field: "CategoryCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        fieldDisplay: "false",
        bodyclass: "bluecolor text_overflow1",
        class: "mediumwidth",
        slot: "CategoryCount",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      StoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      CategoryCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };
    const globalFilterFields = ref(headers.map((col) => col.field));
    const route = useRoute();
    const Iddata = computed(() => {
      return route.query.Id as string;
    });

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response =
          await ItemStoreMappingService.liststorecatgorymapping(usersData.UserId, usersData.OrganizationId, usersData.Admin, usersData.BranchId);
        debugger;

        if (route.query.Id) {
          let count = 0;
          if (usersData.Admin == 1) {
            List.value = response["result"]
              .filter(
                (item) =>
                  item.StoreId == route.query.Id
                // item.HospitalId == usersData.OrganizationId
              )
              .map((item) => {
                count = count + 1;
                item.RowNumber = count;

                return item;
              });
          } else {
            List.value = response["result"]
              .filter(
                (item) =>
                  item.StoreId == route.query.Id
                //item.HospitalId == usersData.OrganizationId 
                //item.BranchId == usersData.BranchId
              )
              .map((item) => {
                count = count + 1;
                item.RowNumber = count;

                return item;
              });
          }
        } else {
          let count = 0;
          if (usersData.Admin == 1) {
            List.value = response["result"]
              //.filter((item) => item.HospitalId == usersData.OrganizationId)
              .map((item) => {
                count = count + 1;
                item.RowNumber = count;

                return item;
              });
          } else {
            List.value = response["result"]
              // .filter(
              //   (item) =>
              //     item.HospitalId == usersData.OrganizationId &&
              //     item.BranchId == usersData.BranchId
              // )
              .map((item) => {
                count = count + 1;
                item.RowNumber = count;
                return item;
              });
          }
        }

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      isMobile.value = window.innerWidth <= 425;
      windowWidth.value = window.innerWidth;
      // change 768 to your desired mobile screen width
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    //Add-New Button-Open Popup
    const IsAdd = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    //TableView
    async function IsShow() {
      debugger
      loading.value = true;
      try {
        const response =
          await ItemStoreMappingService.liststorecatgorymapping(usersData.UserId, usersData.OrganizationId, usersData.Admin, usersData.BranchId);
        debugger;

        if (route.query.Id) {
          let count = 0;
          List.value = response["result"]
            .filter(
              (item) =>
                item.StoreId == route.query.Id
              // item.HospitalId == usersData.OrganizationId &&
              // item.BranchId == usersData.BranchId
            )
            .map((item) => {
              count = count + 1;
              item.RowNumber = count;

              return item;
            });
        } else {
          let count = 0;
          List.value = response["result"]
            // .filter((item) => item.HospitalId == usersData.OrganizationId &&  item.BranchId == usersData.BranchId)
            .map((item) => {
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        }
        console.log(List.value);
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    }

    //Open-EditConfirmation-Popup
    function IsConfirmEdit(data) {
      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    //Open Popup for Edit
    function IsEdit(data) {
      editItems.value = data;
      Editmodel.value = false;
      showDialog.value = true;
    }

    //Open-DeleteConfirmation-Popup
    const contentdel = ref("");
    function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = "Activate?";
        } else if (Status == 2) {
          contentdel.value = "InActivate?";
        } else {
          contentdel.value = "Delete?";
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    let MappingPopup = ref(false);

    //Deleted Sucessfully Popup-Close
    function closetrigger() {
      deletepop.value = false;

      MappingPop.value.visible = false;
    }

    // Map Popup-Close
    function closeMapping() {
      debugger;
      MappingPopUp.value = false;
      Deletemodel.value = false;
    }
    const MappingPop = ref({
      visible: false,
      content: "",
    });

    //Delete Fn
    async function IsDelete(data) {
      loading.value = true;
      debugger;
      try {
        const result = await ItemStoreMappingService.deletestorecatmap(
          data.StoreId
        );
        debugger;
        let message = result["ErrorInfo"].ErrorCode;
        loading.value = false;

        if (message == null) {
          deletepop.value = true;
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopUp.value == true) {
        MappingPopUp.value = false;
        Deletemodel.value = false;
      }
    }

    function RowClick(event: any) {
      debugger;
      // Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    let objectdata = ref({});
    let InActivevisible = ref();
    let Editvisible = ref();

    let Activevisible = ref();
    let Deletevisible = ref();
    const toggle = (event, data) => {
      debugger;
      console.log(event);
      objectdata.value = data;
      if (data.Status == 2) {
        InActivevisible.value = false;
        Activevisible.value = true;
        Editvisible.value = false;
      } else {
        InActivevisible.value = true;
        Activevisible.value = false;
        Editvisible.value = true;
      }
      // Id.value = event.Id
      menu.value.toggle(event);
    };
    const menu = ref();
    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(objectdata.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(objectdata.value, 0);
            },
          },
        ],
      },
    ]);
    function navigatetopage(datacount, datas) {
      if (datacount != 0) {
        editItems.value = datas;
        loading.value = false;
        showDialog.value = true;
      } else {
        // alert('s')
      }
    }
    return {
      ObjOperationId,
      navigatetopage,
      MappingPop,
      itemListed,
      menu,
      contentdel,
      toggle,
      closeMapping,
      MappingPopUp,
      contentName,
      headers,
      List,
      loading1,
      filters,
      IsAdd,
      globalFilterFields,
      showDialog: showDialog,
      generic,
      IsShow,
      IsDelete,
      showgenericright: ref(false),
      IsConfirmDel,
      Deletemodel,
      loading,
      closetrigger,
      IsEdit,
      IsConfirmEdit,
      dataEdit,
      editItems,
      Editmodel,
      RowClick,
      deletepop,
      isMobile,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>

<style>
.mobile-name {
  color: #444444;
  font-size: 16px;
  font-weight: 600;
}

.mobile-id {
  color: #999999;
  font-size: 14px;
}

.mobile-number {
  color: #999999;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>
